import React from 'react';
import { withSSR } from 'react-i18next';
import { registerWidget } from '@okapi/core';
import { getGlobalRouter } from '@okapi/router-react';
import { SERVICES_MAIN_LANDING_NAME } from 'landings/services-main';
import { State } from 'store/types';
import '../../../../i18n.config';
import { ServicesMainRemote } from '../../common/widgets';
import { initWidgetData } from '../init-widget-data';

const WithI18 = withSSR()(ServicesMainRemote);

registerWidget<State, Record<string, string>>(`${__NAME__}/${SERVICES_MAIN_LANDING_NAME}`, state => {
  const router = getGlobalRouter();
  const store = initWidgetData(state);
  const {
    localization: { initialI18nStore, initialLanguage },
  } = state;

  return remoteProps => (
    <WithI18
      initialI18nStore={initialI18nStore}
      initialLanguage={initialLanguage}
      router={router}
      store={store}
      {...remoteProps}
    />
  );
});

